import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import AlertTemplate from "react-alert-template-basic";
import { positions, Provider } from "react-alert";
import { useAlert } from "react-alert";
import {
  Box,
  Stack,
  Chip,
  Typography,
  Grid,
  Paper,
  Switch,
} from "@mui/material";
import {
  Person,
  Lock,
  Email,
  CardMembership,
  IntegrationInstructions,
  Extension,
  Build,
  Send,
  Visibility,
  VisibilityOff,
  CheckCircle,
  Error as ErrorIcon,
  Security,
  AdminPanelSettings,
  Notifications as NotificationsIcon,
  CalendarMonth,
  Link as LinkIcon,
  Image as ImageIcon,
  RequestQuote,
  Description,
  FormatListNumbered,
  Flag,
} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { SUBSCRIPTION_PLANS, PLAN_ORDER } from "../../data/subscriptionPlans";

const sanitizeTextInput = (value, allowDigits = true) => {
  const str = String(value || "").toLowerCase();
  const re = allowDigits ? /[^a-z0-9]/g : /[^a-z]/g;
  return str.replace(re, "");
};

const PLAN_ADDON_MAPPING = {
  consolidatedSummaryWithDiet: "Body Summary",
  covepage: "Cover Page",
  testRecommendation: "Test Recommendation",
  riskScore: "Risk score",
};

const ADDON_DISPLAY_TO_KEY = {
  "Body Summary": "bodySummary",
  "Report Summary": "reportSummary",
  "Test Recommendation": "additionalTestRecommendation",
  "Quick Summary": "quickSummary",
  "Cover Page": "coverPage",
  "Marketing Page": "marketingPage",
  "Risk score": "riskScore",
  "Historical": "historical",
};

const ADDON_ELEMENTS_ORDER = [
  "Body Summary",
  "Report Summary",
  "Test Recommendation",
  "Quick Summary",
  "Cover Page",
  "Marketing Page",
  "Risk score",
  "Historical",
];

const getAddonsFromPlan = (planKey) => {
  if (!planKey) return [];
  const plan = SUBSCRIPTION_PLANS[planKey];
  if (!plan) return [];
  const addons = [];
  const planAddOns = plan.features.addOns;
  Object.keys(PLAN_ADDON_MAPPING).forEach((key) => {
    if (planAddOns[key] === true) {
      addons.push(PLAN_ADDON_MAPPING[key]);
    }
  });
  return addons;
};

const SignUpLab = () => {
  // react alert template options
  const options = {
    timeout: 5000,
    position: "bottom left",
  };
  const alert = useAlert();

  const [typeOfNewClient, setTypeOfNewClient] = useState("");
  const [noticeChangeInValue, setNoticeChangeInValue] = useState(true);
  const [expectedJson, setExpectedJson] = useState("");

  const [userId, setUserId] = useState("");
  const [clientId, setClientId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [org, setOrg] = useState("");
  const [center, setCenter] = useState("");
  const [reportsSubscribed, setReportsSubscribed] = useState(0);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("on hold");
  const [showBilling, setShowBilling] = useState(true);
  const [logoUrl, setLogoUrl] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mailID, setMailId] = useState("");
  const [dashboardAccess, setDashboardAccess] = useState(true);
  const [portalAccess, setPortalAccess] = useState(false);
  const [smartReportAccess, setsmartReportAccess] = useState(false);
  const [reportType, setReportType] = useState("");
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [integrationType, setIntegrationType] = useState("");
  const [vizApp, setVizApp] = useState(false);
  const [aiVideoReports, setAiVideoReports] = useState(false);
  const [languageSupport, setLanguageSupport] = useState(false);
  const [whatsappChatbot, setWhatsappChatbot] = useState(false);
  const [analyticsDashboard, setAnalyticsDashboard] = useState(false);
  const [contentCustomisation, setContentCustomisation] = useState(false);
  const [contentProfile, setContentProfile] = useState(false);
  const [contentParameter, setContentParameter] = useState(false);
  const [designCustomisation, setDesignCustomisation] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const reportTypeMap = {
    compact: "Compact",
    dynamic: "Personal",
    advanced: "Total",
  };

  useEffect(() => {
    let currentLocation = window.location.href;
    let clientType = currentLocation.substring(
      currentLocation.lastIndexOf("/") + 1
    );
    setTypeOfNewClient(clientType);
  }, []);

  useEffect(() => {
    if (!subscriptionType) {
      setSelectedAddons([]);
      setVizApp(false);
      setAiVideoReports(false);
      setLanguageSupport(false);
      setWhatsappChatbot(false);
      setAnalyticsDashboard(false);
      setContentCustomisation(false);
      setContentProfile(false);
      setContentParameter(false);
      setDesignCustomisation(false);
      return;
    }
    const planKey = PLAN_ORDER.find(
      (k) => SUBSCRIPTION_PLANS[k].planName === subscriptionType
    );
    if (!planKey) return;
    const plan = SUBSCRIPTION_PLANS[planKey];
    const features = plan.features;

    const planAddons = getAddonsFromPlan(planKey);
    setSelectedAddons(planAddons);

    setVizApp(features.personalisedServices.vizapp || false);
    setAiVideoReports(features.personalisedServices.videoreport || false);
    setLanguageSupport(
      features.personalisedServices.languageSupport || false
    );
    setWhatsappChatbot(
      features.personalisedServices.whatsappChatbot || false
    );
    setAnalyticsDashboard(
      features.personalisedServices.analyticsDashboard || false
    );

    const contentOn = features.customisation.contentCustomisation || false;
    setContentCustomisation(contentOn);
    setContentProfile(contentOn);
    setContentParameter(contentOn);
    setDesignCustomisation(
      features.customisation.designCustomisation || false
    );

    setNoticeChangeInValue(true);
  }, [subscriptionType]);

  const idToken = localStorage.getItem("idTokenBilling");
  async function createStep(stepData) {
    try {
      const apiEndpoint =
        "https://api.niroggyan.com/onboarding/status/createstep";

      const response = await axios.post(apiEndpoint, stepData, {
        headers: {
          Authorization: `${idToken}`,
        },
      });

      if (response.status === 200) {
        console.log(`Step '${stepData.step_name}' created successfully.`);
      } else {
        console.error(
          `Failed to create step '${stepData.step_name}' with status code ${response.status}.`
        );
      }
    } catch (error) {
      console.error(`Error creating step: ${error.message}`);
    }
  }

  async function createInitialSteps() {
    var currentDate = new Date();
    var firstDeadlineDate = new Date(currentDate);
    firstDeadlineDate.setDate(currentDate.getDate() + 3);
    var secondDeadlineDate = new Date(firstDeadlineDate);
    secondDeadlineDate.setDate(firstDeadlineDate.getDate() + 3);
    var thirdDeadlineDate = new Date(secondDeadlineDate);
    thirdDeadlineDate.setDate(secondDeadlineDate.getDate() + 2);
    var fourthDeadlineDate = new Date(thirdDeadlineDate);
    fourthDeadlineDate.setDate(thirdDeadlineDate.getDate() + 2);

    const stepsData = [
      {
        step_name: "Requirements",
        clientId: clientId,
        status: "notStarted",
        created_at: currentDate,
        completed_at: null,
        completed_by: null,
        dependencyArray: ["nithish@niroggyan.com", "kiran@niroggyan.com"],
        deadline_date: firstDeadlineDate,
        substeps: [
          {
            substep_name: "JSON of a comprehensive package",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Lab report of the same",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Excel with parameter ids",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Header and footer if not sending in JSON",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Doctor signature if not sending in JSON",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Accreditation logos if not sending in JSON",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Cover page in jpg or png format in A4 size",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
        ],
      },
      {
        step_name: "Mapping",
        clientId: clientId,
        status: "notStarted",
        created_at: firstDeadlineDate,
        completed_at: null,
        completed_by: null,
        dependencyArray: ["nithish@niroggyan.com", "kiran@niroggyan.com"],
        deadline_date: secondDeadlineDate,
        substeps: [
          {
            substep_name: "Biomarker Mapping",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Profile Mapping",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Range Mapping",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Report Configurations",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
        ],
      },
      {
        step_name: "Internal Testing",
        clientId: clientId,
        status: "notStarted",
        created_at: secondDeadlineDate,
        completed_at: null,
        completed_by: null,
        dependencyArray: ["nithish@niroggyan.com", "kiran@niroggyan.com"],
        deadline_date: thirdDeadlineDate,
        substeps: [
          {
            substep_name:
              "Header, Footer, Pateint details, Doctor signatures, Accreditation logos",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Parameter names",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Units & Result values",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Method & Ranges",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Result indicator ( normal / abnormal )          ",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Profile grouping",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Report design",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Repetitive / Wrong parameters",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Extra pages",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
        ],
      },
      {
        step_name: "Client Side Testing",
        clientId: clientId,
        status: "notStarted",
        created_at: thirdDeadlineDate,
        completed_at: null,
        completed_by: null,
        dependencyArray: ["nithish@niroggyan.com", "kiran@niroggyan.com"],
        deadline_date: fourthDeadlineDate,
        substeps: [
          {
            substep_name:
              "Header, Footer, Pateint details, Doctor signatures, Accreditation logos",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Parameter names",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Units & Result values",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Method & Ranges",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Result indicator ( normal / abnormal )          ",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Profile grouping",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Report design",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Repetitive / Wrong parameters",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
          {
            substep_name: "Extra pages",
            is_substep_completed: false,
            completed_by: null,
            completed_at: null,
          },
        ],
      },
    ];

    for (const stepData of stepsData) {
      await createStep(stepData);
    }
  }

  const validateForm = () => {
    const trim = (v) => (v != null ? String(v).trim() : "");
    const num = (v) => (v === "" || v == null ? NaN : Number(v));

    if (!trim(userId)) return { valid: false, message: "Account identifiers: User ID is required." };
    if (!trim(clientId)) return { valid: false, message: "Account identifiers: Client Id is required." };
    if (!trim(displayName)) return { valid: false, message: "Account identifiers: Display Name is required." };
    if (!trim(org)) return { valid: false, message: "Account identifiers: Org is required." };
    if (!trim(center)) return { valid: false, message: "Account identifiers: Center is required." };

    if (!trim(password)) return { valid: false, message: "Security: Password is required." };
    if (password.length < 8) return { valid: false, message: "Security: Password must be at least 8 characters." };
    if (!trim(confirmPassword)) return { valid: false, message: "Security: Confirm Password is required." };
    if (password !== confirmPassword) return { valid: false, message: "Security: Passwords do not match." };

    if (!trim(integrationType)) return { valid: false, message: "Integration: Integration Type is required." };

    if (!trim(subscriptionType)) return { valid: false, message: "Subscription: Plan is required." };
    if (!trim(reportType)) return { valid: false, message: "Subscription: Report Type is required." };
    const reportsNum = num(reportsSubscribed);
    if (!Number.isFinite(reportsNum) || reportsNum < 0) return { valid: false, message: "Subscription: Reports Subscribed is required (0 or more)." };
    if (!trim(startDate)) return { valid: false, message: "Subscription: Starting Date is required." };
    if (!trim(endDate)) return { valid: false, message: "Subscription: Ending Date is required." };
    if (!trim(subscriptionStatus)) return { valid: false, message: "Subscription: Subscription Status is required." };
    // Logo URL is not required

    if (!trim(mailID)) return { valid: false, message: "Notifications: Notification Mail Id is required." };

    return { valid: true };
  };

  const handleRequiredJson = async () => {
    const validation = validateForm();
    if (!validation.valid) {
      alert.error(validation.message);
      return;
    }
    const addOnsPayload = {};
    ADDON_ELEMENTS_ORDER.forEach((displayName) => {
      const key = ADDON_DISPLAY_TO_KEY[displayName];
      if (key) addOnsPayload[key] = selectedAddons.includes(displayName);
    });
    let theJson = {
      userId: userId,
      center: center,
      clientId: clientId,
      customerName: displayName,
      displayName: displayName,
      endDate: endDate + " 23:59:59.000",
      logoSrc: logoUrl,
      org: org,
      password: password,
      reportsSubscribed: parseInt(reportsSubscribed),
      role: "lab",
      showBilling: showBilling === true || showBilling === "true",
      startDate: startDate + " 00:00:00.000",
      subscription: subscriptionType ? subscriptionType.toLowerCase() : "",
      subscriptionStatus: subscriptionStatus,
      integrationType: integrationType,
      accessTo: {
        dashBoard: dashboardAccess,
        portal: portalAccess,
        smartReport: smartReportAccess,
      },
      notifications: {
        lastNotifiedAt: 0,
        notifiedAt: 0,
        mailIds: mailID.includes(",") ? mailID.split(",") : [mailID],
        status: "new",
      },
      reportSubscription: {
        reportType: reportType,
        addOns: addOnsPayload,
        personalisedServices: {
          vizapp: vizApp,
          videoreport: aiVideoReports,
          languageSupport,
          whatsappChatbot,
          analyticsDashboard,
        },
        customisation: {
          content: contentCustomisation
            ? { profile: contentProfile, parameter: contentParameter }
            : { profile: false, parameter: false },
          design: designCustomisation,
        },
      },
      reportAddons: selectedAddons,
    };
    // console.log(theJson);

    await setExpectedJson(theJson);
    await setNoticeChangeInValue(false);
  };

  const handleFormSubmission = (e) => {
    e.preventDefault();
    const validation = validateForm();
    if (!validation.valid) {
      alert.error(validation.message);
      return;
    }
    sendDataToBackend();
  };

  const emailHtmlBody = (jsonObj) => {
    let html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Client Signup</title>
      <style>
       body {
        color: black;
       }
      </style>
    </head>
    <body>
      <p>A new client has signed up. Please find the details below.</p>
      <ul>
       <li>Client Name: ${jsonObj.clientName}</li>
       <li>Plan Type: ${jsonObj.planType}</li>
        <li>Report Type: ${jsonObj.reportType}</li>
        <li>Add-ons: ${jsonObj.addOns.join(", ")}</li>

      </ul>
      
    </body>
    </html>
`;
    return html;
  };

  //   const signUpHtmlBody = (jsonObj) => {
  //     let html = `
  //     <!DOCTYPE html>
  //     <html>
  //     <head>
  //       <title>Client Signup</title>
  //       <style>
  //        body {
  //         color: black;
  //        }
  //       </style>
  //     </head>
  //     <body>
  //       <p>Dear ${jsonObj.clientName}</p>
  //        <p>Greetings from NirogGyan!</p>
  //       <p>We’re extremely pleased that you’ve chosen us for generating modern Smart Reports to empower and engage your patients. Your NirogGyan account has been created, and you can access the portal here: <a href="https://www.client-dashboard.niroggyan.com">https://www.client-dashboard.niroggyan.com</a>.
  //       </p>
  //       <p>Thanks,</p>
  //       <p>NirogGyan Team</p>

  //     </body>
  //     </html>
  // `;
  //     return html;
  //   };

  const sendEmailNotification = async () => {
    const signUpDetails = {
      clientName: displayName,
      planType: subscriptionType,
      reportType: reportTypeMap[reportType],
      addOns: selectedAddons,
    };

    let maildata = {
      fromEmail: ["reports@niroggyan.com"],
      toEmail: ["tech@niroggyan.com"],
      // cc: ["nithish@niroggyan.com", "kiran@niroggyan.com"],
      attachments: [],
      withAttachments: "false",
      bodyType: "html",
      emailBody: emailHtmlBody(signUpDetails),
      subject: "New Client Signup",
    };
    const mailApi =
      "https://917sfoy1xc.execute-api.ap-south-1.amazonaws.com/Testing/notifications/email";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(maildata),
    };
    try {
      const response = await fetch(mailApi, options);
      const data = await response.json();
      console.log("mail response", data);
    } catch (e) {
      console.log("error", e);
    }
  };

  const sendDataToBackend = async () => {
    var config = {
      method: "POST",
      // url: "",
      url: "https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/subscription/signup",
      headers: {
        "Content-Type": "application/json",
      },
      data: expectedJson,
      //data: dummyData
    };

    console.log("what im sending:", expectedJson);

    try {
      const axiosData = await axios(config);
      console.log("inside axiosdata ===> \n\n", axiosData);
      if (axiosData.data.insertStatus) {
        alert.success("Signup Successfull");
        createInitialSteps();
        sendEmailNotification();
      } else {
        alert.error(axiosData.data.message);
      }
    } catch (error) {
      console.log("Error for Labs:", error);
      alert.error("Signup Failed!");
    }
  };

  const addonElements = ADDON_ELEMENTS_ORDER;

  const toggleAddon = (name) => {
    setNoticeChangeInValue(true);
    setSelectedAddons((prev) =>
      prev.includes(name) ? prev.filter((x) => x !== name) : [...prev, name]
    );
  };

  const sectionCardSx = {
    p: 3,
    borderRadius: 3,
    border: "1px solid",
    borderColor: "rgba(0,0,0,0.06)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      borderColor: "rgba(0,0,0,0.08)",
    },
  };
  const sectionIconSx = {
    width: 44,
    height: 44,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "primary.main",
    color: "white",
    mr: 2,
  };
  const requiredStar = <Typography component="span" sx={{ color: "#dc2626", fontWeight: 600 }}> *</Typography>;
  const passwordMinLength = 8;
  const passwordLengthOk = password.length >= passwordMinLength;
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSymbol = /[^a-zA-Z0-9]/.test(password);
  const passwordStrongEnough = passwordLengthOk && (hasNumber || hasSymbol);
  return (
    <>
      <Provider template={AlertTemplate} {...options}>
        <Box
          sx={{
            minHeight: "100vh",
            background: "#f3f4f6", // Cleaner, flatter gray for dashboard feel
            py: 4,
            px: { xs: 2, md: 4 },
          }}
        >
          <Box sx={{ maxWidth: "1600px", margin: "0 auto", overflow: "hidden", "& .form-control": { borderRadius: 2, borderColor: "#e5e7eb", minHeight: 38, "&:focus": { borderColor: "primary.main", boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)" } }, "& .form-select": { borderRadius: 2, borderColor: "#e5e7eb", minHeight: 38 }, "& .form-label": { fontWeight: 600, color: "#4b5563" }, "& .input-group-text": { borderRadius: "8px 0 0 8px", borderColor: "#e5e7eb", backgroundColor: "#f9fafb", fontWeight: 600, color: "#4b5563" }, "& .input-group .form-control": { borderRadius: "0 8px 8px 0", minHeight: 38 }, "& .input-group .form-select": { borderRadius: "0 8px 8px 0", minHeight: 38 } }}>
            <Box sx={{ mb: 4, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
              <div>
                <Typography variant="h4" fontWeight={800} sx={{ color: "#111827", letterSpacing: "-0.03em" }}>
                  New Client
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Create a new <strong>{typeOfNewClient || "lab"}</strong> account
                </Typography>
              </div>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Chip label="Draft" size="small" sx={{ bgcolor: "#e5e7eb", fontWeight: 600 }} />
              </Box>
            </Box>

        <Form onSubmit={handleFormSubmission}>
          <Grid container spacing={3} sx={{ "& > .MuiGrid-item": { minWidth: 0 } }}>
          {/* 1. Account identifiers */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={sectionCardSx}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><Person sx={{ fontSize: 24 }} /></Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Account identifiers</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>User ID, Client ID, display name, Org, and Center for this account.</Typography>
                </Box>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon1">User ID{requiredStar}</InputGroup.Text>
                    <Form.Control value={userId} onChange={(e) => { setNoticeChangeInValue(true); setUserId(sanitizeTextInput(e.target.value)); }} placeholder="user id" aria-label="userid" aria-describedby="basic-addon1" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon2">Client Id{requiredStar}</InputGroup.Text>
                    <Form.Control value={clientId} onChange={(e) => { setNoticeChangeInValue(true); setClientId(e.target.value); }} placeholder="client id" aria-label="clientId" aria-describedby="basic-addon2" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon3">Display Name{requiredStar}</InputGroup.Text>
                    <Form.Control value={displayName} onChange={(e) => { setNoticeChangeInValue(true); setDisplayName(e.target.value); }} placeholder="display name" aria-label="displayName" aria-describedby="basic-addon3" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon4">Org{requiredStar}</InputGroup.Text>
                    <Form.Control value={org} onChange={(e) => { setNoticeChangeInValue(true); const v = sanitizeTextInput(e.target.value); setOrg(v); setCenter(v); }} placeholder="org" aria-label="org" aria-describedby="basic-addon4" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon5">Center{requiredStar}</InputGroup.Text>
                    <Form.Control value={center} onChange={(e) => { setNoticeChangeInValue(true); const v = sanitizeTextInput(e.target.value); setCenter(v); setOrg(v); }} placeholder="center" aria-label="center" aria-describedby="basic-addon5" />
                  </InputGroup>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* 2. Security */}
          <Grid item xs={12} sx={{ minWidth: 0 }}>
            <Paper elevation={0} sx={{ ...sectionCardSx, overflow: "hidden" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box sx={sectionIconSx}><Security sx={{ fontSize: 24 }} /></Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Security</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Password for this account (lowercase letters only, no spaces or symbols).</Typography>
                </Box>
              </Box>
              <Stack sx={{ "& > .MuiBox-root": { borderBottom: "1px solid", borderColor: "rgba(0,0,0,0.06)" }, "& > .MuiBox-root:last-of-type": { borderBottom: "none" } }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2, flexWrap: "wrap" }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 120px", minWidth: 0 }}>Password{requiredStar}</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", flex: "1 1 160px", minWidth: 0, maxWidth: 220, position: "relative", "& .form-control": { flex: 1, minWidth: 0 } }}>
                    <Form.Control type={showPassword ? "text" : "password"} value={password} onChange={(e) => { setNoticeChangeInValue(true); setPassword(e.target.value); }} placeholder="password" aria-label="password" style={{ paddingRight: 40 }} />
                    <IconButton size="small" onClick={() => setShowPassword((p) => !p)} aria-label={showPassword ? "Hide password" : "Show password"} sx={{ position: "absolute", right: 4, color: "#64748b" }}>
                      {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2, flexWrap: "wrap" }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 120px", minWidth: 0 }}>Confirm Password{requiredStar}</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", flex: "1 1 160px", minWidth: 0, maxWidth: 220, position: "relative", "& .form-control": { flex: 1, minWidth: 0 } }}>
                    <Form.Control type={showConfirmPassword ? "text" : "password"} value={confirmPassword} onChange={(e) => { setNoticeChangeInValue(true); setConfirmPassword(e.target.value); }} placeholder="retype password" aria-label="confirmpassword" style={{ paddingRight: 40 }} />
                    <IconButton size="small" onClick={() => setShowConfirmPassword((p) => !p)} aria-label={showConfirmPassword ? "Hide password" : "Show password"} sx={{ position: "absolute", right: 4, color: "#64748b" }}>
                      {showConfirmPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </Box>
                </Box>
                {confirmPassword.length > 0 && (
                  <Box sx={{ py: 1.5, display: "flex", flexDirection: "column", gap: 0.5, borderBottom: "none" }}>
                    {password.length < passwordMinLength ? (
                      <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <ErrorIcon sx={{ color: "#dc2626", fontSize: 20 }} />
                          <Typography variant="body2" sx={{ color: "#dc2626", fontWeight: 500 }}>Enter at least 8 characters in Password first.</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ color: "#6b7280" }}>Password has {password.length}/8 characters.</Typography>
                      </>
                    ) : password !== confirmPassword ? (
                      <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <ErrorIcon sx={{ color: "#dc2626", fontSize: 20 }} />
                          <Typography variant="body2" sx={{ color: "#dc2626", fontWeight: 500 }}>Passwords do not match.</Typography>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CheckCircle sx={{ color: "#16a34a", fontSize: 20 }} />
                          <Typography variant="body2" sx={{ color: "#16a34a", fontWeight: 500 }}>Passwords match.</Typography>
                        </Box>
                        {passwordLengthOk && !passwordStrongEnough && (
                          <Typography variant="caption" sx={{ color: "#6b7280" }}>Add numbers or symbols in Password for stronger security.</Typography>
                        )}
                      </>
                    )}
                  </Box>
                )}
              </Stack>
            </Paper>
          </Grid>

          {/* 3. Integration */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={sectionCardSx}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><IntegrationInstructions sx={{ fontSize: 24 }} /></Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Integration</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Model A (NirogGyan server) or Model B (Client server).</Typography>
                </Box>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="integration-type-addon">Integration Type{requiredStar}</InputGroup.Text>
                    <Form.Select aria-label="Integration Type" value={integrationType} onChange={(e) => { setNoticeChangeInValue(true); setIntegrationType(e.target.value); }}>
                      <option value="">Select Option</option>
                      <option value="modelA">Model A</option>
                      <option value="modelB">Model B</option>
                    </Form.Select>
                  </InputGroup>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* 4. Subscription */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                ...sectionCardSx,
                boxShadow: "0 4px 14px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                "&:hover": {
                  boxShadow: "0 12px 28px rgba(0,0,0,0.1), 0 2px 6px rgba(0,0,0,0.06)",
                  borderColor: "rgba(0,0,0,0.08)",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><CardMembership sx={{ fontSize: 24 }} /></Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Subscription</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Plan, report type, reports subscribed, dates, status, logo, and billing.</Typography>
                </Box>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <RequestQuote sx={{ fontSize: 16, color: "primary.main" }} /> Plan{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }} id="sub-plan">Plan{requiredStar}</InputGroup.Text>
                    <Form.Select
                      required
                      value={subscriptionType}
                      onChange={(e) => { setNoticeChangeInValue(true); setSubscriptionType(e.target.value); }}
                      aria-label="subscription"
                      aria-describedby="sub-plan"
                    >
                      <option value="">Select Plan</option>
                      {PLAN_ORDER.map((key) => (
                        <option key={key} value={SUBSCRIPTION_PLANS[key].planName}>
                          {SUBSCRIPTION_PLANS[key].planName}
                        </option>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <Description sx={{ fontSize: 16, color: "primary.main" }} /> Report type{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>Report Type{requiredStar}</InputGroup.Text>
                    <Form.Select aria-label="Report Type" value={reportType} onChange={(e) => { setNoticeChangeInValue(true); setReportType(e.target.value); }}>
                      <option value="">Select type</option>
                      <option value="dynamic">Personal</option>
                      <option value="advanced">Total</option>
                      <option value="compact">Compact</option>
                    </Form.Select>
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <FormatListNumbered sx={{ fontSize: 16, color: "primary.main" }} /> Reports subscribed{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>Reports{requiredStar}</InputGroup.Text>
                    <Form.Control type="number" value={reportsSubscribed} onChange={(e) => { setNoticeChangeInValue(true); setReportsSubscribed(e.target.value); }} placeholder="count" aria-label="reports" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <CalendarMonth sx={{ fontSize: 16, color: "primary.main" }} /> Starting date{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>Start{requiredStar}</InputGroup.Text>
                    <Form.Control type="date" value={startDate} onChange={(e) => { setNoticeChangeInValue(true); setStartDate(e.target.value); }} aria-label="start date" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <CalendarMonth sx={{ fontSize: 16, color: "primary.main" }} /> Ending date{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>End{requiredStar}</InputGroup.Text>
                    <Form.Control type="date" value={endDate} onChange={(e) => { setNoticeChangeInValue(true); setEndDate(e.target.value); }} aria-label="end date" />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <Flag sx={{ fontSize: 16, color: "primary.main" }} /> Status{requiredStar}
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>Status{requiredStar}</InputGroup.Text>
                    <Form.Select aria-label="Subscription Status" value={subscriptionStatus} onChange={(e) => { setNoticeChangeInValue(true); setSubscriptionStatus(e.target.value); }}>
                      <option value="live">LIVE</option>
                      <option value="on hold">HOLD</option>
                    </Form.Select>
                  </InputGroup>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <LinkIcon sx={{ fontSize: 16, color: "primary.main" }} /> Logo URL
                  </Typography>
                  <InputGroup className="mb-0">
                    <InputGroup.Text style={{ fontWeight: "bold", minWidth: "100px" }}>Logo URL</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={logoUrl}
                      onChange={(e) => { setNoticeChangeInValue(true); setLogoUrl(e.target.value); }}
                      placeholder="https://..."
                      aria-label="logoUrl"
                    />
                  </InputGroup>
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: "flex", alignItems: "flex-end" }}>
                  <Box sx={{ width: "100%", py: 1.5, px: 2, display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid", borderColor: "#e5e7eb", borderRadius: 2, backgroundColor: "#fafafa" }}>
                    <Typography variant="body2" fontWeight={600} sx={{ color: "#374151", display: "flex", alignItems: "center", gap: 0.5 }}>
                      <ImageIcon sx={{ fontSize: 18, color: "primary.main" }} /> Show Billing{requiredStar}
                    </Typography>
                    <Switch size="small" checked={showBilling === true || showBilling === "true"} onChange={() => { setNoticeChangeInValue(true); setShowBilling((v) => !v); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* 5. Report Add ons (merged) - grid layout */}
          <Grid item xs={12} sx={{ minWidth: 0 }}>
            <Paper elevation={0} sx={{ ...sectionCardSx, overflow: "hidden" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box sx={sectionIconSx}><Extension sx={{ fontSize: 24 }} /></Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Report Add ons</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Plan add-ons and personalised services (auto-filled when you choose a plan).</Typography>
                </Box>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#374151", mb: 1.5 }}>Report add-ons</Typography>
                  <Grid container spacing={1.5}>
                    {addonElements.map((name) => (
                      <Grid item xs={12} sm={6} key={name}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1, px: 1.5, border: "1px solid", borderColor: "rgba(0,0,0,0.06)", borderRadius: 1.5, backgroundColor: "#fafafa", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                          <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: 1, minWidth: 0 }} noWrap>{name}</Typography>
                          <Switch size="small" checked={selectedAddons.includes(name)} onChange={() => toggleAddon(name)} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#374151", mb: 1.5 }}>Personalised services</Typography>
                  <Grid container spacing={1.5}>
                    {[
                      { label: "Viz App", state: vizApp, set: setVizApp },
                      { label: "AI Video reports", state: aiVideoReports, set: setAiVideoReports },
                      { label: "Language support", state: languageSupport, set: setLanguageSupport },
                      { label: "Whatsapp chatbot", state: whatsappChatbot, set: setWhatsappChatbot },
                      { label: "Analytics dashboard (Marketing)", state: analyticsDashboard, set: setAnalyticsDashboard },
                    ].map(({ label, state, set }) => (
                      <Grid item xs={12} sm={6} key={label}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1, px: 1.5, border: "1px solid", borderColor: "rgba(0,0,0,0.06)", borderRadius: 1.5, backgroundColor: "#fafafa", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                          <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: 1, minWidth: 0 }} noWrap>{label}</Typography>
                          <Switch size="small" checked={!!state} onChange={() => { setNoticeChangeInValue(true); set(!state); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* 6. Customisation */}
          <Grid item xs={12} sx={{ minWidth: 0 }}>
            <Paper elevation={0} sx={{ ...sectionCardSx, overflow: "hidden" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box sx={sectionIconSx}><Build sx={{ fontSize: 24 }} /></Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Customisation</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Content and design customisation (auto-filled from plan).</Typography>
                </Box>
              </Box>
              <Stack sx={{ "& > .MuiBox-root": { borderBottom: "1px solid", borderColor: "rgba(0,0,0,0.06)" }, "& > .MuiBox-root:last-of-type": { borderBottom: "none" } }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2 }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Content customisation</Typography>
                  <Switch size="small" checked={!!contentCustomisation} onChange={() => { setNoticeChangeInValue(true); setContentCustomisation((c) => !c); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                </Box>
                {contentCustomisation && (
                  <>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2, pl: 2 }}>
                      <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Profile</Typography>
                      <Switch size="small" checked={!!contentProfile} onChange={() => { setNoticeChangeInValue(true); setContentProfile((p) => !p); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2, pl: 2 }}>
                      <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Parameter</Typography>
                      <Switch size="small" checked={!!contentParameter} onChange={() => { setNoticeChangeInValue(true); setContentParameter((p) => !p); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                    </Box>
                  </>
                )}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2 }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Design customisation (upto 2 man days)</Typography>
                  <Switch size="small" checked={!!designCustomisation} onChange={() => { setNoticeChangeInValue(true); setDesignCustomisation((d) => !d); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                </Box>
              </Stack>
            </Paper>
          </Grid>

          {/* 7. Access (Switches) */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={sectionCardSx}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><AdminPanelSettings sx={{ fontSize: 24 }} /></Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Access</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Dashboard, portal, and smart report access.</Typography>
                </Box>
              </Box>
              <Stack sx={{ "& > .MuiBox-root": { borderBottom: "1px solid", borderColor: "rgba(0,0,0,0.06)" }, "& > .MuiBox-root:last-of-type": { borderBottom: "none" } }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2 }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>DashBoard Access</Typography>
                  <Switch size="small" checked={!!dashboardAccess} onChange={() => { setNoticeChangeInValue(true); setDashboardAccess((v) => !v); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2 }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Portal Access</Typography>
                  <Switch size="small" checked={!!portalAccess} onChange={() => { setNoticeChangeInValue(true); setPortalAccess((v) => !v); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5, gap: 2 }}>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#374151", flex: "1 1 auto", minWidth: 0 }}>Smart Report Access</Typography>
                  <Switch size="small" checked={!!smartReportAccess} onChange={() => { setNoticeChangeInValue(true); setsmartReportAccess((v) => !v); }} color="primary" sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "primary.main" }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "primary.main" } }} />
                </Box>
              </Stack>
            </Paper>
          </Grid>

          {/* 8. Notifications */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={sectionCardSx}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><NotificationsIcon sx={{ fontSize: 24 }} /></Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Notifications</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Email address(es) for notifications (comma-separated for multiple).</Typography>
                </Box>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography variant="caption" sx={{ color: "#6b7280", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <Email sx={{ fontSize: 16, color: "primary.main" }} /> Notification Mail Id{requiredStar}
                  </Typography>
                  <InputGroup className="mb-3">
                    <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon22" title={"Enter Multiple mail ID's seperated by comma"}>Notification Mail Id{requiredStar}</InputGroup.Text>
                    <Form.Control value={mailID} onChange={(e) => { setNoticeChangeInValue(true); setMailId(e.target.value); }} placeholder="Mail ID" aria-label="Mail ID" aria-describedby="basic-addon22" />
                  </InputGroup>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* 9. Actions */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={sectionCardSx}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2.5 }}>
                <Box sx={sectionIconSx}><Send sx={{ fontSize: 24 }} /></Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} sx={{ color: "#0f172a", letterSpacing: "-0.01em" }}>Actions</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>Confirm your changes and submit the form.</Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap", pt: 1 }}>
                <button
                  type="button"
                  onClick={handleRequiredJson}
                  style={{
                    padding: "10px 24px",
                    borderRadius: 10,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    color: "#64748b",
                    fontWeight: 600,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#f8fafc";
                    e.currentTarget.style.borderColor = "#cbd5e1";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#fff";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  Confirm Changes
                </button>
                <button
                  disabled={noticeChangeInValue}
                  type="submit"
                  style={{
                    padding: "10px 32px",
                    borderRadius: 10,
                    border: "none",
                    background: noticeChangeInValue ? "#cbd5e1" : "#3b82f6",
                    color: "#fff",
                    fontWeight: 600,
                    cursor: noticeChangeInValue ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: noticeChangeInValue ? "none" : "0 2px 8px rgba(59, 130, 246, 0.35)",
                  }}
                  onMouseOver={(e) => {
                    if (!noticeChangeInValue) {
                      e.currentTarget.style.background = "#2563eb";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.4)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!noticeChangeInValue) {
                      e.currentTarget.style.background = "#3b82f6";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.35)";
                    }
                  }}
                >
                  Submit
                </button>
              </Box>
            </Paper>
          </Grid>
          </Grid>
        </Form>
            </Box>
        </Box>
      </Provider>
    </>
  );
};

export default SignUpLab;
